import { Combobox } from "components/DesignSystem/Combobox/Combobox";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useTypedFormikContext } from "hooks/useTypedFormikContext";
import CoinVertical from "static/images/CoinVertical.svg";
import InfoGray from "static/images/InfoGray.svg";

type LaunchFormValues = {
  entity: string;
  season: string;
};

export const IntragroupServiceLaunchBody = ({
  amount,
  description,
  seasons,
  defaultTaskTemplate,
}: {
  amount: string;
  description: string;
  seasons: string[];
  defaultTaskTemplate: string;
}) => {
  const { entities = [] } = useCurrentGroupContext();
  const { values } = useTypedFormikContext<LaunchFormValues>();

  const entityOptions = entities.map(({ uuid, name }) => ({
    label: name,
    value: uuid,
  }));
  const seasonOptions = seasons.map((year) => ({ label: year, value: year }));

  const selectedEntity =
    entityOptions.find(({ value }) => value === values.entity) || null;
  const selectedSeason =
    seasonOptions.find(({ value }) => value === values.season) || null;

  return (
    <div className="t-flex t-gap-4 t-flex-col t-w-full">
      <div className="t-flex t-w-full t-gap-4">
        <Combobox
          withForm
          block
          label="Entity"
          name="entity"
          placeholder="Select entity"
          options={entityOptions}
          value={selectedEntity}
          isClearable={false}
          menuPortalTarget={document.body}
        />
        {!defaultTaskTemplate && (
          <Combobox
            withForm
            block
            label="Season"
            name="season"
            placeholder="Select season"
            options={seasonOptions}
            value={selectedSeason}
            isClearable={false}
            menuPortalTarget={document.body}
          />
        )}
      </div>
      <div className="t-flex t-flex-col t-gap-1 t-mt-2">
        <div className="t-flex t-items-center t-text-body-sm t-font-thin t-text-neutral">
          <img height="15" className="t-mr-2" src={CoinVertical} alt="coin" />
          PRICE
        </div>
        <div className="t-text-subtitle-sm t-text-text-100">${amount}</div>
      </div>
      <div className="t-flex t-flex-col t-gap-1">
        <div className="t-flex t-items-center t-text-body-sm t-font-thin t-text-neutral">
          <img height="15" className="t-mr-2" src={InfoGray} alt="coin" />
          ABOUT
        </div>
        <div
          className="t-text-body-sm t-text-text-100 t-font-light"
          dangerouslySetInnerHTML={{
            __html:
              description?.length > 200
                ? description.substring(0, 160) + "....."
                : description,
          }}
        ></div>
      </div>
    </div>
  );
};
